import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Link, withRouter } from "react-router-dom";
import { Link as MaterialLink } from "@material-ui/core";

import Helper from './Helper';
import { isSubscriptionAvailable, isSubscriptionForParticipantsAvailableAgain } from '../../utils';
import CustomAlert from '../CustomAlert';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        // minHeight: '100vh',
    },
    main: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(2),
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },
}));

function Footer({ showEmail, isChatRoomView }) {
    const classes = useStyles();
    const showHelper = Boolean(showEmail && (isSubscriptionAvailable() || isSubscriptionForParticipantsAvailableAgain()))

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Container component="main" className={classes.main} maxWidth="sm">
                {
                    showHelper && (
                        <>
                            <CustomAlert message="ATENÇÃO: As inscrições devem ser feitas no sistema ConTech e também no sistema UFSC de Inscrições de acordo com seu tipo de inscrição para gerar certificado" />
                            <Helper />
                        </>
                    )
                }
                {
                    !isChatRoomView &&
                    <>
                        <Typography variant="body2" color="textSecondary" align="center">
                            {'Desenvolvido por '}
                            <MaterialLink color="inherit" href="https://vyk1.github.io" target="_blank">
                                {"<Victoria Botelho Martins/>"}
                            </MaterialLink>
                            {' '}
                            {new Date().getFullYear()}
                            {'.'}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" align="center">
                            {'Templated from '}
                            <MaterialLink color="inherit" href="https://github.com/alexanmtz/material-sense" target="_blank">
                                material-sense
                    </MaterialLink>
                        </Typography>
                    </>
                }

                {
                    showEmail && (
                        <Typography variant="body2" color="textSecondary" align="center">
                            <Link to="/login" color="inherit">
                                Á. Rest.
                            </Link>
                        </Typography>

                    )
                }
            </Container>
        </div >
    );
}

Footer.defaultProps = {
    showEmail: false,
    isChatRoomView: false
}
export default withRouter(Footer)
